(() => {
  const root = window.Shopify?.routes?.root || '/';
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(scope = document) {
    scope.querySelectorAll('[data-ulti-video]').forEach(video => {
      if (initialized.has(video)) return;
      initialized.add(video);
      const button = video.parentElement.querySelector('[data-video-toggle]');
      if (!button || !video.dataset.source) return;
      const updateControl = () => {
        const label = video.paused ? 'Play video' : 'Pause video';
        button.setAttribute('aria-label', label);
        button.title = label;
        button.textContent = video.paused ? '\u25B6' : '\u23F8';
      };
      const start = async () => {
        if (!video.isConnected) return;
        video.src ||= video.dataset.source;
        video.playbackRate = 0.7;
        try { await video.play(); } catch {}
        updateControl();
      };
      button.hidden = false;
      updateControl();
      button.addEventListener('click', async () => {
        if (video.paused) await start();
        else { video.pause(); updateControl(); }
      });
      const constrained = reducedMotion.matches || navigator.connection?.saveData ||
        /(^|-)2g$/.test(navigator.connection?.effectiveType || '') ||
        window.matchMedia('(max-width: 767px)').matches;
      if (!constrained) {
        const observe = () => {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              observer.disconnect();
              start();
            }
          });
          observer.observe(video);
        };
        if (document.readyState === 'complete') observe();
        else window.addEventListener('load', observe, { once: true });
      }
    });
  }

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-ulti-product], [data-ulti-newsletter]')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-form-status]');
    const originalLabel = button.textContent;
    form.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Please wait...';
    status.textContent = '';
    try {
      if (document.body.dataset.localPreview === 'true') throw new Error('This local preview does not submit live cart or newsletter requests. Open the product on ulti.sg to shop.');
      if (form.matches('[data-ulti-product]')) {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Could not add this item. Please try again.');
        status.append(document.createTextNode('Added to your cart. '));
        const link = document.createElement('a');
        link.href = `${root}cart`;
        link.textContent = 'View cart';
        status.append(link);
        document.dispatchEvent(new CustomEvent('ulti:cart-added', { detail: result }));
      } else {
        const company = form.dataset.company;
        const list = form.dataset.list;
        if (!company || !list) throw new Error('Newsletter signup is unavailable. Please contact us.');
        const values = new FormData(form);
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          body: JSON.stringify({ data: {
            type: 'subscription', attributes: {
              custom_source: 'Homepage newsletter signup form',
              profile: { data: { type: 'profile', attributes: {
                email: values.get('email').trim(), first_name: values.get('first_name').trim(),
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            }, relationships: { list: { data: { type: 'list', id: list } } }
          } })
        });
        if (!response.ok) throw new Error('Something went wrong. Please try again.');
        status.textContent = "You're on the list! Check your email for the next steps.";
        form.reset();
      }
    } catch (error) {
      status.textContent = error.message || 'Could not reach the service. Please try again.';
    } finally {
      form.dataset.busy = 'false';
      button.disabled = false;
      button.textContent = originalLabel;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.ulti-header details[open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
})();
